export const CHANNEL_HELP_TOOLTIP_MESSAGE =
  'A channel is a way visitors communicate through your website, like filling out a form. A unique name helps you sort different user activities when reviewing them later.';
